var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { RestServiceBase } from '@ane/core/lib/services/RestServiceBase';
import { onError } from '@ane/core/lib/decorators/OnError';
import { constructQueryString, getFlightQueryParams } from '../../../utils/FlightRoute.utils';
import EnvironmentService from '@ane/core/lib/services/EnvironmentService';
class CompositionResource extends RestServiceBase {
    constructor() {
        super(EnvironmentService.endpoints.legacy, '/api/2.0/tenants/');
        this._errorMessage = (RestResult, response) => {
            return response && response.ExceptionMessage;
        };
    }
    _v2APIPath(tenantId) {
        return `${tenantId}/flights/`;
    }
    loadComposition(flightId, managementGroup, tenant, workspaceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryString = constructQueryString(getFlightQueryParams(managementGroup, workspaceId));
            const address = `${this._v2APIPath(tenant)}${flightId}/composition${queryString}`;
            const result = yield this._get(address);
            return result;
        });
    }
    loadDependency(flightId, managementGroup, tenant, workspaceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.tryLoadDepdency(flightId, managementGroup, tenant, workspaceId);
            return result;
        });
    }
    tryLoadDepdency(flightId, managementGroup, tenant, workspaceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryString = constructQueryString(getFlightQueryParams(managementGroup, workspaceId));
            const address = `${this._v2APIPath(tenant)}${flightId}/dependency${queryString}`;
            return yield this._get(address);
        });
    }
    updateCompositionBatch(managementGroup, tenant, workspaceId, updateRequest, verifyOnly, submitWithBlocking) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseAddress = `${this._v2APIPath(tenant)}composition/batch`;
            return this.updateCompositionShared(baseAddress, workspaceId, managementGroup, updateRequest, verifyOnly, submitWithBlocking);
        });
    }
    updateCompositionShared(baseAddress, workspaceId, managementGroup, updateRequest, verifyOnly, submitWithBlocking) {
        return __awaiter(this, void 0, void 0, function* () {
            const verifyOnlyParam = `&verifyOnly=${verifyOnly ? 'true' : 'false'}`;
            const blockingParam = `&submitWithBlocking=${submitWithBlocking ? 'true' : 'false'}`;
            const params = [...getFlightQueryParams(managementGroup, workspaceId), verifyOnlyParam, blockingParam];
            const query = constructQueryString(params);
            const address = `${baseAddress}${query}`;
            const result = yield this._put(updateRequest, address);
            return result;
        });
    }
}
__decorate([
    onError({ message: `An error occurred while loading the flight's composition.` })
], CompositionResource.prototype, "loadComposition", null);
__decorate([
    onError({ message: `An error occurred while loading the flight compositon's dependencies.` })
], CompositionResource.prototype, "loadDependency", null);
__decorate([
    onError({ message: `An error occurred while updating the composition.` })
], CompositionResource.prototype, "updateCompositionBatch", null);
export default new CompositionResource();

//# sourceMappingURL=Composition.resource.js.map
